import { cn } from '@mint-lib/tw-utils';

import { typographyVariants } from './typography.jsx';

function Badge({
  content,
  variant = 'dot',
  color,
  invisible = false,
  children,
}: {
  variant?: 'standard' | 'dot';
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  content?: number;
  children: React.ReactNode;
  invisible?: boolean;
}) {
  return (
    <div className="relative flex items-center">
      <div
        data-slot="badge"
        data-variant={variant}
        data-invisible={invisible}
        data-color={color}
        className="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 rounded-full outline-offset-2 data-[color=error]:bg-error-main data-[color=error]:text-error-contrastText data-[color=info]:bg-info-main data-[color=info]:text-info-contrastText data-[color=primary]:bg-primary-main data-[color=primary]:text-primary-contrastText data-[color=secondary]:bg-secondary-main data-[color=secondary]:text-secondary-contrastText data-[color=success]:bg-success-main data-[color=success]:text-success-contrastText data-[color=warning]:bg-warning-main data-[color=warning]:text-warning-contrastText data-[invisible=true]:hidden data-[variant=dot]:size-2 data-[variant=standard]:flex data-[variant=standard]:w-fit data-[variant=standard]:items-center data-[variant=standard]:justify-center"
      >
        <span
          data-invisible={invisible}
          data-variant={variant}
          className={cn(
            typographyVariants({
              variant: 'caption2',
            }),
            'data-[invisible=true]:hidden data-[variant=dot]:hidden data-[variant=standard]:mx-[5.5px] data-[variant=standard]:my-0.5',
          )}
        >
          {content}
        </span>
      </div>

      <span>{children}</span>
    </div>
  );
}

export { Badge };
